export const packagingTypesMap: Record<string, string> = {
  "loose-bag": "Loose Bag",
  "retail-carton": "Retail Carton",
  "corrugated-carton": "Corrugated Carton",
  other: "Other",
};

export const packagingMaterialsMap: Record<string, string> = {
  plastic: "Plastic",
  cardboard: "Cardboard",
  wood: "Wood",
  metal: "Metal",
  glass: "Glass",
  other: "Other",
};

export const plasticTypesMap: Record<string, string> = {
  abs: "ABS",
  acetal: "Acetal",
  acrylic: "Acrylic",
  "butyl-rubber": "Butyl Rubber",
  pet: "PET",
  polyethylene: "Polyethylene",
  polypropylene: "Polypropylene",
  polystyrene: "Polystyrene",
  polyurethane: "Polyurethane",
  pvc: "PVC",
  other: "Other",
};

export const storageTypesMap: Record<string, string> = {
  "single-row-pallet-racks": "Single-row pallet racks",
  "double-row-pallet-racks": "Double-row pallet racks",
  "multiple-row-racks-small": "Multiple-row racks ≤16′ depth",
  "multiple-row-racks-large": "Multiple-row racks >16′ depth",
  "palletized-solid-pile": "Palletized/solid pile (floor stack)",
  "shelf-storage": "Shelf storage / Back-to-back shelves",
  "catwalk-system": "Catwalk system",
  "under-mezzanine-storage": "Under-mezzanine storage",
  other: "Other",
};

export const rackAccessoriesMap: Record<string, string> = {
  "wire-mesh-grating": "Wire mesh grating",
  "pallet-supports": "Pallet supports",
  "slatted-shelves": "Slatted shelves",
  "open-shelf": "Open shelf",
};
